import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/common/btn_close.png'


const _hoisted_1 = { class: "mask" }
const _hoisted_2 = {
  key: 0,
  class: "title display-y-center display-s-b"
}
const _hoisted_3 = { class: "content" }

import { currentChannel } from '@/config/config';



export default /*@__PURE__*/_defineComponent({
  __name: 'TipDefault',
  props: {
    title: {
        type: String,
        default: "",
    },
    isShowClose: {
        type: Boolean,
        default: true
    },
    isShowHeader: {
        type: Boolean,
        default: true,
    }
},
  emits: ["onClose"],
  setup(__props, { emit: __emit }) {



const emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["tip-content item-center", _unref(currentChannel).channel])
    }, [
      (__props.isShowHeader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.title), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      (__props.isShowClose)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            class: "btn-close",
            src: _imports_0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onClose')))
          }))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})